export default _ =>
  process.env.NODE_ENV === "production" && (console.log = () => {});
